import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Textarea,
  Typography,
  Tooltip,
} from "@material-tailwind/react";
import { FaCheck, FaTimes, FaTrashRestore, FaTrashRestoreAlt } from "react-icons/fa";
import { FaRegFolderOpen, FaReply } from "react-icons/fa6";
import useAuth, { useOrder } from "../../hooks/useAuth";
import axios from "axios";
import { apiUrl, errorToast, getFileDownloadURL, successToast } from "../../utils/firebase/firebase.utils";
import { TbCloudDownload } from "react-icons/tb";
import { LuArchiveRestore } from "react-icons/lu";
import { MdRestore } from "react-icons/md";
 
const ReplyDialog = ({ inquiry, onStatusChange }) => {

  const { currentUser } = useAuth()
  const { updateInquiry } = useOrder()
//   const [inquiry, setInquiry] = useState(inquiry);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(!open);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(!open2);

  const updateReply = async (event) => {
    event.preventDefault()
    inquiry['status'] = 'yes'
    inquiry['inq_response'] = event.target.reply_txt.value

    const fwdMail = await axios.put(apiUrl()+'/sendmail/nomail', inquiry)
    if (fwdMail) {
        console.log('Result: ', fwdMail.data.result)
    } else {
        console.log('Mail Error: ', fwdMail.message)
        return
    }
        // onStatusChange(inquiry)
        // handleOpen()

    await updateInquiry(inquiry).then(
        console.log(event.target.reply_txt.value),
        onStatusChange(inquiry),
        handleOpen(),
    )

  }

  const updateInq = async (txt) => {
    inquiry['status'] = txt

    await updateInquiry(inquiry).then(
        onStatusChange(inquiry),
    )
  }



  const handleDownload = async () => {
    // const filePath = "files/bday.png";
    const filePath = "compressed_files/"+inquiry.fileinc+".zip";
    try {
      // Get the file's download URL from Firebase Storage
      const downloadURL = await getFileDownloadURL(filePath);
      successToast('Download Complete');
      handleOpen2();

      // Create an anchor element and trigger the download
      const link = document.createElement("a");
      link.href = downloadURL; // Set the file URL as the link's href
    //   link.download = "Jaysfiles.zip"; // Suggested file name for download
      document.body.appendChild(link); // Append to DOM (required for Firefox)
      link.click(); // Trigger the click to download
      document.body.removeChild(link); // Clean up after download
    } catch (error) {
      console.error("Failed to download file:", error);
      errorToast("Failed to download the file. Please try again later.");
      handleOpen2();
    }
  };

    // useEffect(()=>{
    //     setInquiry(inquiry)
    // }, [open])
 
  return (
    <>
        {/* <Button onClick={handleOpen}>Message Dialog</Button> */}
        {inquiry.status == 'no' ? 
        <>
        <Button className='reply-btn shadow-none hover:shadow-none text-xs capitalize font-normal' onClick={handleOpen}><FaReply className='float-left mt-0.5' />&nbsp;&nbsp;Reply</Button>
        <Tooltip content="Confirm Reply" className="bg-gray-200/70 text-gray-500">
            <Button className='reply-btn shadow-none hover:shadow-none text-xs capitalize font-normal' onClick={()=>updateInq('yes')}><FaCheck className='float-left mt-0.5' /></Button>
        </Tooltip>
        {/* <Button className='reply-btn shadow-none hover:shadow-none text-xs capitalize font-normal !text-red-500'><FaTimes className='float-left mt-0.5' /></Button> */}
        {inquiry.fileinc && inquiry.fileinc != 'no' && inquiry.type == 'translation' ?
        <Tooltip content="View Files" className="bg-gray-200/70 text-gray-500">
            <Button className='reply-btn shadow-none hover:shadow-none text-xs capitalize font-normal' onClick={handleOpen2}><FaRegFolderOpen className='float-left mt-0.5' /></Button>
        </Tooltip>
        :null}
        </>
        :
        <>
        <Button className='reply-btn shadow-none hover:shadow-none hover:!bg-gray-100 text-xs capitalize font-normal !text-gray-400/70'><FaReply className='float-left mt-0.5' />&nbsp;&nbsp;Reply</Button>
        {/* <Button className='reply-btn shadow-none hover:shadow-none hover:!bg-gray-100 text-xs capitalize font-normal !text-gray-400/70'><FaCheck className='float-left mt-0.5' /></Button> */}
        <Tooltip content="Restore" className="bg-gray-200/80 text-gray-500">
            <Button className='reply-btn shadow-none hover:shadow-none text-xs capitalize font-normal !text-red-500' onClick={()=>updateInq('no')}><LuArchiveRestore size={14} className='float-left mt-0.5' /></Button>
        </Tooltip>
        {inquiry.fileinc && inquiry.fileinc != 'no' && inquiry.type == 'translation' ?
            <Button className='reply-btn shadow-none hover:shadow-none hover:!bg-gray-100 text-xs capitalize font-normal !text-gray-400/70'><FaRegFolderOpen className='float-left mt-0.5' /></Button>
        :null}
        </>
        }
        
        <Dialog open={open} size="xs" handler={handleOpen}>
            <div className="flex items-center justify-between">
            <DialogHeader className="flex flex-col items-start">
                {" "}
                <Typography className="mb-1" variant="h5">
                Reply to @{inquiry.name}
                </Typography>
            </DialogHeader>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
                onClick={handleOpen}
            >
                <path
                fillRule="evenodd"
                d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                clipRule="evenodd"
                />
            </svg>
            </div>
            <form onSubmit={updateReply}>
                <DialogBody>
                    <div className="grid gap-6">
                        <Input label="From Admin" value={currentUser ? currentUser.displayName :null} readOnly/>
                        <Textarea name="reply_txt" label="Message" required/>
                    </div>
                </DialogBody>
                <DialogFooter className="space-x-2">
                <Button variant="text" color="gray" onClick={handleOpen}>
                    cancel
                </Button>
                <Button type="submit" variant="gradient" color="gray">
                    send message
                </Button>
                </DialogFooter>
            </form>
        </Dialog>


        <Dialog open={open2} size="sm" handler={handleOpen2}>
            <div className="flex items-center justify-between">
            <DialogHeader className="flex flex-col items-start">
                {" "}
                <Typography className="mb-1" variant="h5">
                Attachments
                </Typography>
            </DialogHeader>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
                onClick={handleOpen2}
            >
                <path
                fillRule="evenodd"
                d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                clipRule="evenodd"
                />
            </svg>
            </div>
            <form>
                <DialogBody className="place-items-center">
                    <p className="mb-3 text-center mx-4">File uploads from {inquiry.name}</p>
                    <Button variant="gradient" color="gray" onClick={handleDownload}>
                        <TbCloudDownload size={20} className="float-left mr-2 -mt-1" />
                        Download Files
                    </Button>
                </DialogBody>
                <DialogFooter className="space-x-2">
                <Button variant="text" color="gray" onClick={handleOpen2}>
                    Close
                </Button>
                </DialogFooter>
            </form>
        </Dialog>
    </>
  );
}

export default ReplyDialog